import { Navigate, Outlet } from 'react-router-dom'

import ContentHeader from '@/components/structure/content-header'
import { routeNames } from '@/configs/routePaths'
import { useUserContext } from '@/contexts/user.context'
import useLocalStorage from '@/hooks/common/use-local-storage';
import Constants from '@/configs/constants';

export function WithAuth() {
  const forceSanitization = String((atob(useLocalStorage(Constants.FORCE_SANITIZATION, btoa('false'))[0]))).toLowerCase() === "true";
  const { isAuthenticated } = useUserContext();
 
  if (!isAuthenticated) {
    return (
      <>
        <Navigate to={routeNames.login} replace />
      </>
    )
  } else if (forceSanitization) {
    return (
      <>
        <Navigate to={routeNames.sanitization} replace />
      </>
    )
  }

  return (
    <>
      <ContentHeader />
      <Outlet />
    </>
  )
}
